<script setup lang="ts">
const { loadBadges } = useSmarticoBadges();
const { badges } = storeToRefs(useSmarticoBadges());

onMounted(async () => {
  if (badges?.value?.length === 0) {
    await loadBadges();
  }
});
</script>

<template>
  <div :class="$style['smartico-badges']">
    <BaseCommonMainTitle>
      <span>{{ $t('gamification.badges') }}</span>
    </BaseCommonMainTitle>

    <div class="grid grid-cols-4 gap-4">
      <div
        v-for="badge in badges"
        :key="badge.id"
        :class="[$style.badge, { [$style.locked]: !badge.is_completed }]"
      >
        <img
          :alt="badge.name"
          :src="badge.image"
        />
        <span :class="$style.title">{{ badge.name }}</span>
      </div>
    </div>
  </div>
</template>

<style module lang="postcss">
.smartico-badges {
  @apply mb-10;
  .badge {
    text-align: center;
    &.locked {
      opacity: 0.1;

      img {
        filter: grayscale();
      }
    }

    .title {
      color: #fff;
      font-weight: 700;
      font-size: 1.2rem;
    }
  }
}
</style>
